$(document).ready(() => {
  const exibeModalOptin = LumisPortal.getCookie('exibeModalOptin');

  if (exibeModalOptin != null && exibeModalOptin == 'true') {
    if (isShoppingAdm())
      $('#modal-optin label').text(
        'Autorizo o uso de meus dados pessoais incluídos neste formulário por este shopping para fins de comunicação e gestão de relacionamento contínuo. Nesse sentido, autorizo que meus dados sejam utilizados para comunicação sobre eventos, envio de pesquisas de satisfação, divulgação produtos e serviços oferecidos por este shopping, ações promocionais futuras e para a divulgação de ofertas, produtos, serviços e/ou recomendações personalizadas. Você poderá revogar esse consentimento no futuro.',
      );

    let islink = false;
    $('.navigation__sublink').each(function (index) {
      if ($(this).text().toUpperCase() == 'POLÍTICA DE PRIVACIDADE' && !islink) {
        $('#modal-optin label').append('<br><br>');
        $('#modal-optin label').append(
          'Você poderá revogar esse consentimento no futuro. Para mais informações sobre o uso de dados pessoais, acesse a <a href="' +
            $(this).attr('href') +
            '">Política de privacidade</a>',
        );

        islink = true;
      }
    });

    $('#modal-optin').addClass('is-open');
    document.cookie = 'exibeModalOptin=false;path=/';
  }
});

function setOptin() {
  dataLayerEnviaOptIn();
  $('#modal-optin .modal__content button').addClass('button--loading');
  const optin = $('input[name=consentimento-optin]:checked').length > 0 ? 'true' : 'false';

  $.ajax({
    url: g_LumisRoot_href + 'perfil/client/editOptIn',
    type: 'POST',
    data: { optIn: optin },
    success: function (data) {
      $('#modal-optin').removeClass('is-open');
      $('#modal-optin .modal__content button').removeClass('button--loading');
    },
    error: function (data) {
      $('#modal-optin').removeClass('is-open');
      $('#modal-optin .modal__content button').removeClass('button--loading');

      alert('Ocorreu um erro ao processar sua solicitação');
    },
  });
}

function isShoppingAdm() {
  const empreendimentoId = $('#empreendimentoId').attr('title');

  return (
    empreendimentoId == 'PASSEIO_SHOPPING' ||
    empreendimentoId == 'RECREIO_SHOPPING' ||
    empreendimentoId == 'SAO_GONCALO_SHOPPING' ||
    empreendimentoId == 'SHOPPING_PRACA_NOVA_ARACATUBA' ||
    empreendimentoId == 'SHOPPING_WEST_PLAZA' ||
    empreendimentoId == 'PRACA_NOVA_SHOPPING' ||
    empreendimentoId == 'PARQUE_SHOPPING_BAHIA' ||
    empreendimentoId == 'BOULEVARD_SHOPPING_FEIRA_DE_SANTANA' ||
    empreendimentoId == 'MONTES_CLAROS_SHOPPING'
  );
}
